export default __webpack_public_path__ + "static/media/starbuck-logo.09b40415.svg";